import type { VariationComponent } from "~types/types";

export default function integrityCheck(props: VariationComponent) {
    const messages = [];

    if (!props.embedUrl) {
        messages.push("No Embed Url");
    }

    return messages;
}
